import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import {FilePdfTwoTone} from '@ant-design/icons';

const {Text} = Typography;
const Content = Layout;

const SWBWL = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>The use of Southwestern Blot is meant to study the DNA aptamer sequence interactions with proteins beyond CRP. Using fluorescence, native-PAGE gel electrophoresis and a transfer membrane, it is possible to detect the specificity of the aptamers.<br/><br/><b>Goal:</b> To determine if the aptamers have specificity towards CRP and not other molecules present in the blood.<br/><br/>This protocol was not performed due to lack of time and resources, however it was designed and planned to be performed in the future or if it serves to other iGEM teams for future aptamer’s investigations. </Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Content style={{width: '15vh', marginLeft: '54vh', background: 'transparent'}}><p><i>Go to pdf</i></p></Content>
              <a style={{width: 'fit-content', marginLeft: '58vh'}} target='_blank' rel='noopener noreferrer' href='https://static.igem.wiki/teams/4464/wiki/wet-lab/pdfs/2-swb.pdf'><FilePdfTwoTone style={{fontSize: '8vh'}} twoToneColor='#eb2f96'/></a>
            </Content>
          </Layout>
        </Content>
        <Divider/>
      </Layout>
    </Layout>
  );
};

export default SWBWL;
